<template>
    <section class="content">
        <box>
            <div slot="body">
            

            <form-wizard @on-complete="onComplete" shape="square" color="#20a0ff" error-color="#ff4949" title="Cadastro de Novo Usuário" subtitle="Avance pelas guias para finalizar o cadastro">
                
                <!-- TAB DE DADOS PESSOAIS -->
                <tab-content title="Dados Pessoais" icon="fa fa-user" :before-change="validateFirstStep">
                <el-form :model="dadosPessoais" class="demo-form-inline" :rules="rules" ref="ruleForm">
                    <el-form-item label="User Name" prop="userName" class="form-item">
                        <div class="input-group input-group-lg">
                            <span class="input-group-addon" id="sizing-addon1"><i class="fa fa-user"></i></span>
                            <input v-model="dadosPessoais.userName" type="text" class="form-control" placeholder="Nome de usuário" aria-describedby="sizing-addon1">
                        </div>
                    </el-form-item>
                    <el-form-item label="Foto" prop="img" class="form-item">
                        <div class="input-group input-group-lg">
                            <span class="input-group-addon" id="sizing-addon1"><i class="fa fa-file-image-o" aria-hidden="true"></i></span>
                                <input type="file" id="file-input" class="form-control">
                            <!--<input v-model="dadosPessoais.img" type="text" class="form-control" placeholder="URL da foto" aria-describedby="sizing-addon1">-->
                        </div>
                    </el-form-item>
                </el-form>
                </tab-content>

                <!-- TAB DE CREDENCIAIS -->
                <tab-content title="Credenciais" icon="fa fa-lock" :before-change="validateSecondStep">
                    <el-form :inline="true" :model="dadosLogin" class="demo-form-inline" :rules="rulesLogin" ref="ruleFormLogin">
                        <el-form-item label="Email para Login" prop="email" class="form-item">
                        <div class="input-group input-group-lg">
                            <span class="input-group-addon" id="sizing-addon1"><i class="fa fa-envelope"></i></span>
                            <input v-model="dadosLogin.email" type="text" class="form-control" placeholder="Email" aria-describedby="sizing-addon1">
                        </div>
                        </el-form-item>
                        <el-form-item label="Senha de Acesso" prop="password" class="form-item">
                        <div class="input-group input-group-lg">
                            <span class="input-group-addon" id="sizing-addon1"><i class="fa fa-key"></i></span>
                            <input v-model="dadosLogin.password" type="password" class="form-control" placeholder="Senha de Acesso" aria-describedby="sizing-addon1">
                        </div>
                        </el-form-item>
                        <el-form-item label="Empresas" prop="fullName" class="form-item">
                            <multi-select 
                                :options="options"
                                :selected-options="dadosLogin.itens"
                                placeholder="Empresas com permissão"
                                @select="onSelect">
                            </multi-select>
                        </el-form-item>
                    </el-form>
                </tab-content>

                <!-- TAB DE CONFIRMAÇÃO -->
                <tab-content title="Confirmar Dados" icon="fa fa-check">
                    <div class="row">                         
                        <div class="col-sm-2">
                            Nome de Usuário: 
                        </div>
                        <div class="col-sm-4">
                            <input class="form-control" type="text" :value="dadosPessoais.userName" disabled>
                        </div>
                    </div>
                    <div class="row">                         
                        <div class="col-sm-2">
                            Email: 
                        </div>
                        <div class="col-sm-4">
                            <input class="form-control" type="text" :value="dadosLogin.email" disabled>
                        </div>
                    </div>
                    <div class="row">                         
                        <div class="col-sm-2">
                            Senha: 
                        </div>
                        <div class="col-sm-4">
                            <input class="form-control" id="password" type="password" :value="dadosLogin.password" disabled>
                            <a v-show="!mostrandoSenha" href="javascript:;" @click="mostrarSenha('mostrar')"><span class="badge">Mostrar Senha</span></a>
                            <a v-show="mostrandoSenha" href="javascript:;" @click="mostrarSenha('')"><span class="badge">Ocultar Senha</span></a>     
                        </div>
                    </div>
                    <div class="row">                         
                        <div class="col-sm-2">
                            Empresas: 
                        </div>
                        <div class="col-sm-4">
                            <input class="form-control" type="text" :value="empresas" disabled>
                        </div>
                    </div>
                    
                </tab-content>

                <el-button type="primary" class="btn btn-primary" slot="prev">Anterior</el-button>
                <el-button type="primary" class="btn btn-primary" slot="next">Próximo</el-button>
                <el-button v-show="!gravando" type="primary" class="btn btn-primary" slot="finish" >Confirmar</el-button>
                <el-button v-show="gravando" type="primary" class="btn btn-primary" slot="finish" disabled><i class="fa fa-spinner fa-spin"></i>Confirmar</el-button>
            </form-wizard>


            </div>
        </box>

    </section>
</template>
<script>
import _ from 'lodash'
import axios from 'axios'
import Modal from './Modal' // importando modal
import Box from './Box'
import firebase from 'firebase'
import { MultiSelect } from 'vue-search-select'
import $ from 'jquery'
import decrypt from '../../services/decrypt.js'

export default {
  name: 'NovoUsuario',
  components: {
    'modal': Modal,
    'box': Box,
    MultiSelect
  },
  data() {
      return {
        email_atual : window.localStorage.getItem('usuario'),
        senha_atual: decrypt.descriptografar(localStorage.getItem('password')),
        options: [],
        gravando: false,
        mostrandoSenha: false,
        dadosPessoais: {
          fullName: '',
          userName: '',
          img: ''
        },
        dadosLogin: {
          email: '',
          password: '',
          itens: []
        },
        rules: {
            fullName: [{
              required: true,
              message: 'Por favor informe o nome completo',
              trigger: 'blur' // ou 'change'
            }],
            userName: [{
              required: true,
              message: 'Por favor Informe o nome de usuário',
              trigger: 'blur'
            }]
         },
         rulesLogin: {
            email: [{
                required: true,
                message: 'Por favor informe o email',
                trigger: 'blur'
            }],
            password: [{
                required: true,
                message: 'Por favor informe a senha',
                trigger: 'blur'
            }, {
                min: 6,
                max: 15,
                message: 'Senha deve ter entre 6 e 15 caracteres',
                trigger:'change'
            }],
            itens: [{
                required: true,
                message: 'Por favor informe as empresas que terá acesso',
                trigger: 'blur'
            }],
            
         }
        }
       },
       computed: {
           empresas: function() {
               var empresas = ''
               for (let i in this.dadosLogin.itens) {
                   if (empresas === '') empresas = this.dadosLogin.itens[i].text
                   else empresas += '/ ' + this.dadosLogin.itens[i].text
               }
               return empresas
           }
       },
       created() {
           this.ajusteOptions (this.$store.state.empresas)    
       },
       methods: {
        onSelect (itens, lastSelectItem) {
            this.dadosLogin.itens = itens
            setTimeout(function(){ 
                $('.delete').removeClass('detele').addClass('fa fa-trash');
            }, 100);
        },
        // deselect option
        reset () {
            this.dadosLogin.itens = [] // reset
        },
        ajusteOptions(empresas) {
            for(let i = 0; i < empresas.length ; i++) {
                this.options.push({ text: empresas[i].nome, value: i, id: empresas[i].id })
            }
        },
        onComplete: function() {
            this.gravando = true
            this.newUsuario()
         },
         newUsuario () {
            firebase.auth().createUserWithEmailAndPassword(this.dadosLogin.email, this.dadosLogin.password)
            .then(() => {   
                const files = document.getElementById('file-input').files;
                const file = files[0];
                if(file != null){
                    this.getSignedRequest(file);
                } else {
                    this.gravarUsuario();
                }  
            })
            .catch(function(error) {
                // Handle Errors here.
                // var errorCode = error.code
                var errorMessage = error.message
                document.getElementById('error').textContent = errorMessage
                this.gravando = false
                // ...
            });
         },
         getSignedRequest(file){
            const xhr = new XMLHttpRequest();
            console.log(file.name)
            xhr.open('GET', this.$store.state.api+`s3/sign-s3?file-name=${file.name}&file-type=${file.type}`);
            xhr.onreadystatechange = () => {
                if(xhr.readyState === 4){
                    if(xhr.status === 200){
                        const response = JSON.parse(xhr.responseText);
                        this.uploadFile(file, response.signedRequest, response.url);
                    }
                    else{
                        this.gravando = false
                        alert('Could not get signed URL.');
                    }
                }
            };
            xhr.send();
        },
        uploadFile(file, signedRequest, url){
            const xhr = new XMLHttpRequest();
            xhr.open('PUT', signedRequest);
            xhr.onreadystatechange = () => {
                if(xhr.readyState === 4){
                    if(xhr.status === 200){
                        this.dadosPessoais.img = url;
                        // console.log()
                        this.gravarUsuario();
                    }
                    else{
                        alert('Por favor, selecione uma imagem.');
                        this.gravando = false
                    }
                }
            };
            xhr.send(file);
        },
        gravarUsuario() {
            if (!this.dadosPessoais.img) this.dadosPessoais.img = 'https://wordsandvideos.com/wp-content/uploads/2016/12/common.png'
            axios.post('https://sev-delivery.herokuapp.com/api/usuarios/insert', {
                'nome_usuario': this.dadosPessoais.userName,
                'email': this.dadosLogin.email,
                'foto': this.dadosPessoais.img,
                'empresas': this.dadosLogin.itens
            }).then(response => {
                    if (response.data.success) {
                        this.dadosLogin.itens.forEach(empresa => {
                            let url = this.$store.state.empresas[empresa.value].api;

                            axios.post(`${url}usuarios`, {
                                'email': this.dadosLogin.email
                            }).catch((err) => {
                                console.log(`Usuário não foi gravado na empresa ${empresa.nome}.`)
                            })
                        });

                        firebase.auth().signInWithEmailAndPassword(this.email_atual, this.senha_atual).then(
                            (user) => {
                                this.$router.push('dashboard')
                                this.$swal({
                                    position: 'top-end',
                                    type: 'success',
                                    title: 'Gravado com sucesso',
                                    showConfirmButton: false,
                                    timer: 1500
                                })
                            },
                            (Error) => {
                                console.log(Error.message)
                            }
                        )
                    } else {
                        this.$swal(
                        'Ops!',
                        'Usuário não foi gravado.',
                        'error'
                        )
                        this.gravando = false
                    }
            })
        },
         validateFirstStep() {
           return new Promise((resolve, reject) => {
             this.$refs.ruleForm.validate((valid) => {
               resolve(valid);
               document.addEventListener
             });
           })
         },
         validateSecondStep() {
           return new Promise((resolve, reject) => {
             this.$refs.ruleFormLogin.validate((valid) => {
                 if(this.dadosLogin.itens.length === 0) valid = false
               resolve(valid);
             });
           })

         },
         mostrarSenha (change) {
            if (change === 'mostrar') {
                document.getElementById('password').type = 'text'
                this.mostrandoSenha = true 
            } else {
                document.getElementById('password').type = 'password'
                this.mostrandoSenha = false
            }
         }
       }
}
</script>
<style>
.el-form-item__error{
    color: red
}
.form-item{
        margin-bottom: 2%;
}
</style>



// WEBPACK FOOTER //
// NovoUsuario.vue?c88cf0bc